import React, { Component } from "react";
import moment from "moment";
import { connect } from "react-redux";
import ReactTooltip from "react-tooltip";
import Session from "../../utility/session";
import { loadPaymentHistory } from "../../Containers/Settings/actions";
import { dateFormats } from "../../utility/enums";
import { numberWithCommas } from "../../utility/commonHelpers";
import { clearData } from "../../Containers/EmailValidation/actions";
import { CLEAR_SETTINGS_PAYMENT_HISTORY } from "../../common/constants";
const mapStateToProps = state => ({
  paymentHistory: state.settingsInfo.paymentHistory
});
class PaymentHistory extends Component {
  constructor(props) {
    super(props);
    this.handleScroll = this.handleScroll.bind(this);
    this.calculateDiscountedAmount = this.calculateDiscountedAmount.bind(this);
  }
  loadData = (page, limit) => {
    const custId = Session.getItem(Session.MM_CUSTOMER_ID)
    if(custId && custId !== "0"){
      this.props.dispatch(
        loadPaymentHistory({
          page,limit,
          mmCustomerID: custId 
        })
      );
    }
  }
  componentDidMount() {
    window.addEventListener("scroll", this.handleScroll);
    this.loadData(1, 10)
  }
  componentWillUnmount() {
    window.removeEventListener("scroll", this.handleScroll);
    this.props.dispatch(clearData(CLEAR_SETTINGS_PAYMENT_HISTORY))
  }
  handleScroll() {
    let winHeight = window.innerHeight;
    let scrollTop = document.documentElement.scrollTop;
    let scrollHeight = document.body.scrollHeight;
    const statsComponent = document.querySelector(".emails-stats-right");
    const emailVerification = document.querySelector(".emailVerification");
    if (statsComponent) {
      if (this.sticky == undefined)
        this.sticky = statsComponent.getBoundingClientRect().top;
      if (window.pageYOffset >= this.sticky) {
        statsComponent.classList.add("sticky");
        statsComponent.style.width =
          emailVerification.getBoundingClientRect().width / 2 + "px";
      } else if (statsComponent) {
        statsComponent.classList.remove("sticky");
        statsComponent.style.width = "";
      }
    }
    const selectedFileComponent = document.querySelector(".activeTimeline");
    if (selectedFileComponent) {
      if (this.stickyFile == undefined)
        this.stickyFile = selectedFileComponent.getBoundingClientRect().top;

      if (window.pageYOffset + 50 >= this.stickyFile) {
        selectedFileComponent.classList.add("sticky-left");
        selectedFileComponent.style.width =
          parseInt(emailVerification.getBoundingClientRect().width / 2) -
          70 +
          "px";
      } else {
        selectedFileComponent.classList.remove("sticky-left");
        selectedFileComponent.style.width = "";
      }
    }
    if (scrollHeight == winHeight + scrollTop) {
      console.log("Page Bottom load more files");
      const {
        limit,
        page,
        pages,
      } = this.props.paymentHistory;
      if (pages >= page + 1) {
        console.log(`Has more triggered`)
          this.loadData(
            page+1,
            limit,
          )
      }
    }
  }
  calculateDiscountedAmount(totalAmount, adjustment) {
    return parseInt(totalAmount - adjustment);
  }
  render() {
    const paymentHistory = this.props.paymentHistory;
    return (
      <div role="tabpanel" className="tab-pane fade" id="tab_content3" aria-labelledby="profile-tab">
        <table className="data table table-striped no-margin">
          <thead>
            <tr>
              <th width="20%">Date</th>
              <th width="30%">Package</th>
              <th width="20%">Price</th>
              <th width="10%">Invoice</th>
              <th width="10%">TransactionID</th>
              <th width="10%">Status</th>
            </tr>
          </thead>
          <tbody>
            {paymentHistory.loading && paymentHistory.docs.length == 0 ? "" :
            paymentHistory.docs.length > 0 ?
              paymentHistory.docs.map((payment, index) => (
                <tr key={index}>
                  {/* <td>{payment.TransactionDate}</td> */}
                  <td>{new moment(payment.TransactionDate).format(dateFormats.DATE_TIME_FORMAT)}</td>
                  <td>
                    {numberWithCommas(payment.Size)}&nbsp;Verifications-{payment.planGroup}
                    {payment.subscriptionType == undefined || payment.subscriptionType == ""
                      ? ""
                      : "(" + payment.subscriptionType + ")"}
                  </td>
                  <td>
                    {payment.subscriptionType == undefined || payment.subscriptionType == ""
                    ? "$" + numberWithCommas(payment.discountedprice)
                      : "$" +
                        numberWithCommas(this.calculateDiscountedAmount(payment.discountedprice, payment.adjustment)) +
                        "(" +
                        "$" +
                        numberWithCommas(payment.discountedprice) +
                        "-" +
                        "$" +
                        numberWithCommas(payment.adjustment) +
                        ")"}

                    {payment.subscriptionType == undefined || payment.subscriptionType == "" ? (
                      ""
                    ) : (
                      <p
                        className="adjustment-info"
                        data-tip={
                          "Previous Plan Amount : $" +
                          payment.previousPlanAmount +
                          " Previous plan days : " +
                          payment.previousPlanFrequency +
                          " Charge Per Day : $" +
                          payment.chargePerDay +
                          " Previous Plan Unused Days : " +
                          payment.previousPlanUnusedDays
                        }
                      >
                        <i className="fa fa-question-circle" aria-hidden="true" />
                      </p>
                    )}
                    <ReactTooltip />
                  </td>
                  <td>{payment.InvoiceNumber}</td>
                  <td>{payment.TransactionRefID}</td>
                  <td>
                    {payment.TransactionStatus}
                    {payment.response == undefined || payment.response == "" ? "" : "(" + payment.response + ")"}
                  </td>
                </tr>
              )) : <tr>
                  <td colSpan="6" style={{textAlign:"center", opacity:0.7}}>You haven't made any payments.</td>
                </tr>}
          </tbody>
        </table>
      </div>
    );
  }
}
export default connect(mapStateToProps)(PaymentHistory);



// WEBPACK FOOTER //
// ./src/components/Settings/PaymentHistory.js